import React from 'react'
import MesHeroSection from './MesHeroSection'
import WhyMes from './WhyMES'
import Faq from './FAQ'
import MesOperations from './MesOperations'
import WhatIsMes from './WhatIsMes'
import FeaturesSection from './MesFeatures'
import ContactForm from './ContactMes'
import MESFunctionality from './MESFunctionality'
import InforCapabilities from './MesKeyCapabilities'
const MES = () => {
  return (
    <div>
          <section>
              <MesHeroSection/>
          </section>

          
          <section>
        <MESFunctionality/>
              
          </section>
          
          <section>
              
              <InforCapabilities/>
               </section>

          <section>
              
             <WhatIsMes/>
          </section>

          <section>
              <WhyMes/>
          </section>

         <section>
              <FeaturesSection/>
          </section>

          <section>
              <MesOperations/>
          </section>

          

           <section>
              <Faq/>
          </section>

          <section>
              <ContactForm/>
          </section>
    </div>
  )
}

export default MES
